import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Fre-Tool Interfaces",
description: "Interfaces implemented by generated Freon code, defining extensibility points such as environment, scoper, typer, validator, reader, writer, and standard library access.",
tags: [ "Tool Interfaces", "FreEnvironment", "FreScoper", "FreValidator", "FreTyper", "FreReader", "FreWriter", "FreStdlib", "Freon"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};